import { useCallback } from 'react';
import { kebabCase, last } from 'lodash';
import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData';
import { useLandingPagesApi } from 'services/api/landingPagesApi';
import { chatSender } from '../consts/chatState';
import { INITIAL_VERSION, INITIAL_TOTAL_VERSIONS } from '../consts/versionConstants';

const merger = (_, data) => data;

export const useHandleChatSubmit = () => {
    const { chatEditLandingPage, getVersions } = useLandingPagesApi();
    const { patchExternalData } = useFormDataContext();

    const chatSubmitHandler = async landingPage => {
        const { accountName, landingPageId, chatHistory = [], versionNumber = INITIAL_VERSION } = landingPage;
        const prompt = last(chatHistory)?.text ?? '';
        let newState;

        try {
            // Chat edit with active version number
            const chatResponse = await chatEditLandingPage({
                accountName,
                landingPageId,
                prompt,
                activeVersionNumber: versionNumber,
            });

            const { landingPage: newLandingPage, summary: newAiMessage } = chatResponse;

            // Get updated total versions count after chat
            const versionsResponse = await getVersions({ accountName, landingPageId });
            const totalVersions = versionsResponse?.totalVersions || INITIAL_TOTAL_VERSIONS;
            const newVersionNumber = newLandingPage.versionNumber || totalVersions - 1;

            newState = {
                ...newLandingPage,
                // Convert title back to kebab-case for form (backend returns startCase)
                title: kebabCase(newLandingPage.title),
                landingPageId,
                chatHistory: [...chatHistory, { sender: chatSender.ai, text: newAiMessage }],
                versionNumber: newVersionNumber,
                totalVersions,
                navigationTimestamp: Date.now(),
            };
        } catch (error) {
            console.error(error);
            newState = {
                ...landingPage,
                chatHistory: [
                    ...chatHistory,
                    {
                        sender: chatSender.ai,
                        messageId: 'landing.pages.edit.chat.error.message',
                        defaultText: 'Something went wrong while editing the landing page. Please try again.',
                    },
                ],
            };
        }
        patchExternalData({ data: newState, merger });
        return newState;
    };

    return useCallback(chatSubmitHandler, [chatEditLandingPage, getVersions, patchExternalData]);
};
